module.exports = __webpack_public_path__ + "static/media/brandings.a8ca347c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/brandings.png
// module id = 992
// module chunks = 0